// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.6.0",
    "short": "58fe766",
    "branch": "Detached: 58fe7660ee7a0a97d42f72b9c2dae1bf7df5633e",
    "date": "2026-9-21"
};
/* eslint:enable */
